import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { ProtectedRoute, HomeRedirector } from './components';
import { AuthProvider } from './contexts/AuthContext';
import SchoolPage from './pages/SchoolPage';
import GuardianPage from './pages/GuardianPage';
import PlayPage from './pages/PlayPage';
import ProfilePage from './pages/ProfilePage';
import LearndleWordPage from './pages/games/LearndleWordPage';
import CrosswordPage from './pages/games/CrosswordPage';
import ChildDashboardPage from './pages/ChildDashboardPage';
import LoginPage from './pages/LoginPage';
import GuardianLoginPage from './pages/GuardianLoginPage';
import ChildrenLoginPage from './pages/ChildrenLoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage';

// Create a custom theme for the educational platform
const theme = createTheme({
  palette: {
    primary: {
      main: '#1ea7fd',
    },
    secondary: {
      main: '#ff4785',
    },
    background: {
      default: '#04bcd7',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
    h1: {
      fontSize: '2rem',
      fontWeight: 600,
      textAlign: 'center',
    },
  },
  spacing: 8,
});

// Removed unused HomePage component

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/login/guardian" element={<GuardianLoginPage />} />
            <Route path="/login/children" element={<ChildrenLoginPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomeRedirector />
                </ProtectedRoute>
              }
            />
            <Route
              path="/school"
              element={
                <ProtectedRoute>
                  <SchoolPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/guardian"
              element={
                <ProtectedRoute requireUserType="guardian">
                  <GuardianPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requireUserType="child">
                  <ChildDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play"
              element={
                <ProtectedRoute requireUserType="child">
                  <PlayPage />
                </ProtectedRoute>
              }
            />

            {/* Games routes */}
            <Route
              path="/games/learndle-word"
              element={
                <ProtectedRoute requireUserType="child">
                  <LearndleWordPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/games/crossword"
              element={
                <ProtectedRoute requireUserType="child">
                  <CrosswordPage />
                </ProtectedRoute>
              }
            />

            {/* Catch all - redirect to login */}
            <Route path="/*" element={<LoginPage />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
